<div *ngIf="!childConfig.isHidden" class="tml-tpl-ctrl-wrap" [style.width.px]="childConfig.css.width">
    <div class="tam-contact-control" tid="Employment Job Title">
        <label>Job Title</label>
        <input class="tam-input" [(ngModel)]="inputValue" [style.width.px]="childConfig.css.leftWidth"
            [maxLength]='childConfig.maxLength||128' [style.height.px]="childConfig.height"
            [placeholder]="childConfig.hint||''" (ngModelChange)="textChange($event)" [disabled]="true" />
    </div>

    <div class="tam-contact-control" tid="Employment Start Year">
        <label>Start Year</label>
        <kendo-dropdownlist [style.width.px]="childConfig.css.rightWidth" [popupSettings]="{appendTo: 'component'}"
            (valueChange)="valueChange($event)" [(ngModel)]="selectedItem" #dropDownEl [data]="suggestionItems"
            [filterable]="true" (filterChange)="handleFilter($event)" class="contact-dropdown"
            (focus)="dropDownEl.toggle(true)" (mousedown)="$event.preventDefault()">
            <ng-template kendoMultiSelectHeaderTemplate>
                <div class="popup-template-clear-header">
                    <span class="multiselect-Clear" (click)="clearValue()">Clear</span>
                </div>
            </ng-template>
        </kendo-dropdownlist>
    </div>
</div>
<div class="contact-label-add-more" *ngIf="childConfig.config.isSupportDynamic" (click)="clickAddCtrol($event)">
    <label>{{childConfig.config.addlabel}}</label>
</div>